import { SkeletonHeaders } from "../SkeletonHeaders";
import { ErrorPanel, type ErrorInfo } from "./ErrorPanel";
interface Level2OuterPageLoadingProps {
    errors?: ErrorInfo[];
}
export function Level2OuterPageLoading({ errors }: Level2OuterPageLoadingProps) {
    if (errors && errors.length > 0) {
        return errors.map((error: ErrorInfo, index) => <ErrorPanel key={index} error={error}/>);
    }
    return <SkeletonHeaders showBreadcrumbSkeleton={true}/>;
}
